// extracted by mini-css-extract-plugin
export default {"content":"etdCusqP","actions":"_9HdChuy","title":"ptdtFHcm","email":"flJrTrDD","button":"KhllliGq"};